import React, { useEffect, useState } from "react";
import Handler from "../../Helpers/Components/Handler";
import { useNavigate, useParams } from "react-router-dom";
import { reloadWindowToPath } from "../../Helpers/Utils";
import DatePicker from "react-multi-date-picker";
import CountUp from "react-countup";
import { toast } from "react-toastify";
import Modal from "../../Helpers/Components/Modal"
import Report from "./Report"

const View = () => {
    const [subadmin, setSubadmin] = useState({})
    const [count, setCount] = useState({})
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const validEmail = new RegExp('([a-z0-9.]{2,})+@([a-z]{3,})+([.]{1})+[a-z]{2,3}')
    const [editDetails, setEditDetails] = useState({})
    const navigate = useNavigate()
    const [editModal, setEditModal] = useState(false)
    const [month, setMonth] = useState(new Date())
    const getSubadmin = async () => {
        const response = await Handler({ method: "get", url: `/admin/subadmin/view/${id}` })
        if (response?.success) {
            setSubadmin(response?.data)
        } else {
            reloadWindowToPath(`/subadmin/1`)
        }
    }
    const getCount = async () => {
        const response = await Handler({ method: 'post', data: { month }, url: `/admin/subadmin/report/${id}` })
        if (response?.success) {
            setCount(response?.data)
        } else {
            toast.error(response?.message)
        }
    }
    const handleChange = (e) => {
        setEditDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const handleSubmit = async () => {
        if (!(editDetails?.name)) {
            toast.error("Name is required");
        } else if ((!validName.test(editDetails?.name))) {
            toast.error("Invalid Name");
        } else if (!(editDetails?.phone)) {
            toast.error("Phone Number is required");
        } else if (!(editDetails?.email)) {
            toast.error("Email is required");
        } else if (!validEmail.test(editDetails?.email)) {
            toast.error("Email is Invalid");
        } else {
            setLoading(true)
            const response = await Handler({ url: `admin/subadmin/update/${id}`, data: editDetails, method: 'patch' })
            if (response?.success) {
                toast.success(response?.message);
                setTimeout(() => {
                    reloadWindowToPath(`/subadmin/view/${id}`);
                }, 1000);
            } else {
                setLoading(false)
                toast.error(response?.message)
            }
        }
    }
    useEffect(() => {
        getSubadmin()
    }, [])
    useEffect(() => {
        getCount()
    }, [month])

    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <h5 className="text-center text-theme fs-4">Subadmin View</h5>
            <div className="row justify-content-around align-items-center mt-4 gap-4">
                <div className="col-xl-4 col-lg-6 col-md-8">
                    <div className="card">
                        <div className="text-center fw-bold  text-theme cardHeading card-header">
                            SubAdmin Information
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> ID </div> </div>
                                <div className="col"><div className="card-text">  {subadmin?.id || "-"} <i className="fa-solid fa-pen-to-square cursor-pointer ms-2" onClick={() => { setEditDetails((prev) => ({ ...prev, ...subadmin, phone: subadmin?.phone || subadmin?.mobile })); setEditModal(true) }}></i> </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Name </div> </div>
                                <div className="col"><div className="text-capitalize card-text">  {subadmin?.name || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Phone Number </div> </div>
                                <div className="col"><div className="card-text">  {subadmin?.phone || subadmin?.mobile || "-"} </div> </div>
                            </div>
                            <div className="row">
                                <div className="col"> <div className="headingCard card-title"> Email </div> </div>
                                <div className="col"><div className="card-text">  {subadmin?.email || "-"} </div> </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-8">
                    <div className="dashboardCard card">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden ms-3">
                                    <p className="fw-medium text-muted mb-3">Overall Collections</p>
                                    <h4 className="fs-4 flex-grow-1 mb-2 d-flex justify-content-between">
                                        <CountUp end={count?.amount || 0} duration={2} className="text-theme" />
                                        <i className="fa-solid fa-indian-rupee-sign fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row my-4 justify-content-center">
                <div className="col-xl-2 col-sm-4">
                    <div className=" datepicker-top">
                    <DatePicker
                        className="form-control text-center reactDate"
                        onlyMonthPicker
                        value={month}
                        onChange={(e) => setMonth(new Date(e))}
                    />
                    </div>
                </div>
            </div>
            <div className="row my-4">
                <div className="col-xl-3 col-lg-6 col-12">
                    <div className="card dashboardCard">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden ms-3">
                                    <p className="fw-medium text-muted mb-3">Total Customers</p>
                                    <h4 className="fs-4 flex-grow-1 mb-2 d-flex justify-content-between">
                                        <CountUp end={count?.customer} duration={2} className="text-theme" />
                                        <i className="fa-solid fa-person fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-12 mt-lg-0 mt-4">
                    <div className="card dashboardCard">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden ms-3">
                                    <p className="fw-medium text-muted mb-3">Completed bookings</p>
                                    <h4 className="fs-4 flex-grow-1 mb-2 d-flex justify-content-between">
                                        <CountUp end={count?.completed} duration={2} className="text-theme" />
                                        <i className="fa-solid fa-book-open fs-2" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-12 mt-xl-0 mt-4">
                    <div className="card dashboardCard">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden ms-3">
                                    <p className="fw-medium text-muted mb-3">No. of Pendings</p>
                                    <h4 className="fs-4 flex-grow-1 mb-2 d-flex justify-content-between">
                                        <CountUp end={count?.pending} duration={2} className="text-theme" />
                                        <i className="fa-solid fa-hourglass-start fs-2"></i>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-12 mt-xl-0 mt-4">
                    <div className="card dashboardCard">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden ms-3">
                                    <p className="fw-medium text-muted mb-3">No. of Cancelled</p>
                                    <h4 className="fs-4 flex-grow-1 mb-2 d-flex justify-content-between">
                                        <CountUp end={count?.cancelled} duration={2} className="text-theme" />
                                        <i className="fa-solid fa-user-xmark bx-md" style={{ "color": "black", "backgroundColor": "#fff" }}></i>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Report />
            <Modal header={"Update Subadmin"} onShow={editModal} toggle={() => setEditModal(false)} overlayToggle={() => setEditModal(false)}>
                <div className="my-3">
                    <label htmlFor="name" className="mb-1"> Name</label>
                    <input disabled={loading} autoComplete="off" id="name" name="name" className="form-control input-theme" placeholder="Name" value={editDetails?.name || ""} onChange={handleChange} type="text" />
                </div>
                <div className="my-3">
                    <label htmlFor="phone" className="mb-1">Phone</label>
                    <input disabled={loading} autoComplete="off" id="phone" name="phone" className="form-control input-theme" placeholder="Phone" value={editDetails?.phone || subadmin?.mobile || ""} maxLength={10} onChange={(e) => { if (e.target.value == Number(e.target.value)) { handleChange(e) } }} type="text" />
                </div>
                <div className="my-3">
                    <label htmlFor="email" className="mb-1">Email</label>
                    <input disabled={loading} autoComplete="off" id="email" name="email" className="form-control input-theme" placeholder="Email" value={editDetails?.email || ""} onChange={handleChange} type="text" />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-success btn-sm" disabled={loading} onClick={handleSubmit}>
                        {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}
                    </button>{' '}
                    <button className="btn btn-danger btn-sm" disabled={loading} onClick={() => setEditModal(false)}>
                        {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Cancel"}
                    </button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default View;